import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import BigButton from "@/components/buttons/BigButton.vue";
import WInput from "@/components/form/w-input.vue";
import axios from "axios";
import { alertError } from "@/util/dialog";
import Loader from "@/components/loader/Loader.vue";
import { waitingJob } from "@/util/job.utils";
import { AISpeachOption } from "@/models/ai/aiSpeach.model";
import { getVisualTemplateByKey } from "@/models/ai/aiVisualTemplate.model";
import { SubChapterType } from "@/models/ai/aiSubChapter.model";
import { getSubChapterTypeConfig } from "@/models/ai/aiSubChapterTypeConfig.model";
import LightButton from "@/components/buttons/LightButton.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import AIChapterContentGenerator from "@/components/aiSpeachGenerator/AIChapterContentGenerator.vue";
import { toSpeachEditingPage } from "@/util/routeUtil";
import AISpeachGeneratorPanelOption from "@/components/aiSpeachGenerator/AISpeachGeneratorPanelOption.vue";
import delay from "delay";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import prettyMilliseconds from "pretty-ms";
let AIStepsGenerator = class AIStepsGenerator extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "aiFiles", []);
    _defineProperty(this, "uploadedFiles", []);
    _defineProperty(this, "language", void 0);
    _defineProperty(this, "duration", void 0);
    _defineProperty(this, "specificPrompt", void 0);
    _defineProperty(this, "allowReorder", void 0);
    _defineProperty(this, "weetEndpoint", void 0);
    _defineProperty(this, "generationMode", void 0);
    _defineProperty(this, "fullContentGeneration", void 0);
    // DEMO_MODE (confined user): only "Generate all" is offered on the generation screen (no save & edit).
    _defineProperty(this, "demoMode", void 0);
    _defineProperty(this, "linkId", void 0);
    // Style step choices — forwarded down to AIChapterContentGenerator so they
    // land in the WeetInitiator, and also persisted into speachGenerated
    // .generationOptions on validate so the AISpeach JSON keeps them for
    // "Continue via AI".
    _defineProperty(this, "styleAvatar", void 0);
    _defineProperty(this, "styleBackground", void 0);
    _defineProperty(this, "styleVoice", void 0);
    _defineProperty(this, "styleImageStyle", void 0);
    _defineProperty(this, "styleVisualTemplate", void 0);
    _defineProperty(this, "styleExplainerEnabled", void 0);
    _defineProperty(this, "styleQuizEnabled", void 0);
    _defineProperty(this, "styleAnnotationsEnabled", void 0);
    _defineProperty(this, "styleFullExplainer", void 0);
    _defineProperty(this, "styleUseAvatar", void 0);
    _defineProperty(this, "showConfirmGenerateAll", false);
    _defineProperty(this, "showGenerationStarted", false);
    _defineProperty(this, "pushingChapters", false);
    // Countdown (s) gating the "close" button of the generation-started dialog.
    // Disabled until it reaches 0; clicking it then redirects to the editor.
    _defineProperty(this, "closeCountdown", 0);
    _defineProperty(this, "closeCountdownTimer", null);
    _defineProperty(this, "generatedSpeachID", '');
    _defineProperty(this, "languageSelected", "");
    _defineProperty(this, "durationSelected", "");
    _defineProperty(this, "specificPromptSelected", "");
    _defineProperty(this, "allowReorderSelected", false);
    _defineProperty(this, "openElement", []);
    _defineProperty(this, "generationInProgress", true);
    _defineProperty(this, "showOptionPanel", false);
    _defineProperty(this, "speachGenerated", null);
    _defineProperty(this, "speachToMap", null);
    _defineProperty(this, "indexLecon", -1);
    _defineProperty(this, "indexChapter", -1);
    _defineProperty(this, "weetIDMap", {});
    // Keys ("<indexChapter>-<indexSubChapter>") of QUIZ subchapters whose
    // one-click generation is currently running (drives the inline loader).
    _defineProperty(this, "quizGeneratingKeys", {});
    // Upper bound of questions when the LLM picks the count itself (nb=0).
    _defineProperty(this, "QUIZ_MAX_QUESTIONS", 10);
  }
  // Emit true once the speach is mapped (plan → generation phase) so the parent
  // stepper can switch from "Plan" to "Generation".
  onSpeachToMapChange() {
    this.$emit('generationPhase', !!this.speachToMap);
  }
  /** Plan phase: go back to the style/options step (parent handles it). */
  onBack() {
    this.$emit('back');
  }
  mounted() {
    this.languageSelected = this.language;
    this.durationSelected = this.duration;
    this.allowReorderSelected = this.allowReorder;
    this.specificPromptSelected = this.specificPrompt;
    this.generateLLMSteps();
  }
  generateLLMSteps() {
    this.generationInProgress = true;
    const formData = new FormData();
    this.aiFiles.forEach(el => {
      formData.append('jobIDs', el.jobID);
    });
    formData.append("language", this.languageSelected);
    formData.append("duration", this.durationSelected);
    formData.append("specificPrompt", this.specificPromptSelected);
    formData.append("allowReorder", this.allowReorderSelected + "");
    formData.append("explainerEnabled", this.styleExplainerEnabled + "");
    formData.append("quizEnabled", this.styleQuizEnabled + "");
    formData.append("fullExplainer", this.styleFullExplainer + "");
    axios.post('/recorder/aiSpeachGenerator/generateSteps', formData).then(async resp => {
      this.waitStepGenerationProceed(resp.data);
    }).catch(e => {
      this.generationInProgress = false;
      alertError(this.$t('aiContent.error'));
    });
  }
  openAllElement() {
    this.openElement = [];
    if (this.speachGenerated) {
      let i = 0;
      for (const chapter of this.speachGenerated?.chapters) {
        this.openElement.push("chapter" + i);
        i++;
      }
    }
  }
  regenerate() {
    this.showOptionPanel = false;
    this.generateLLMSteps();
  }
  async waitStepGenerationProceed(jobID) {
    try {
      const data = await waitingJob(jobID);
      this.speachGenerated = data;
      this.openAllElement();
      this.generationInProgress = false;
    } catch (e) {
      console.error(e);
      alertError(this.$t('aiContent.error'));
    }
  }
  updateDocumentSpeachGenerated() {
    // Associate subchapter.documentPage.jobID with aiFile.jobID based on document name
    if (!this.speachGenerated || !this.aiFiles || this.aiFiles.length === 0) return;
    // Loop through all chapters and subchapters
    for (const chapter of this.speachGenerated.chapters) {
      for (const subchapter of chapter.subchapters) {
        // Process each document page in the subchapter
        for (const documentPage of subchapter.documentPages) {
          // Extract document index from document name (e.g., document_1 → index 1)
          const documentIndex = documentPage.documentNumber;
          // Find the corresponding AI file (adjusting for 0-based array index)
          const aiFile = this.aiFiles[documentIndex - 1];
          if (aiFile) {
            // Associate job IDs
            documentPage.jobID = aiFile.jobID;
          }
        }
      }
    }
  }
  async validateAiSpeach(goToEditing) {
    if (this.speachToMap) {
      document.location = toSpeachEditingPage(this.speachToMap.speachID);
    } else {
      this.updateDocumentSpeachGenerated();
      this.generationInProgress = true;
      if (!this.speachGenerated) {
        return;
      }
      this.speachGenerated.generationOptions = new AISpeachOption();
      this.speachGenerated.generationOptions.generationMode = this.generationMode;
      this.speachGenerated.generationOptions.lang = this.languageSelected;
      // customInstruction = user's raw prompt only. The visual template's
      // hiddenPrompt is now injected per-subchapter via SUB_CHAPTER_TYPE_CONFIG
      // (only for EXPLAINER), so merging it globally would pollute every
      // subchapter's <trainingModule> context — including SLIDE/QUIZ
      // that must not follow the stickman/whiteboard/etc. style.
      this.speachGenerated.generationOptions.customInstruction = this.specificPromptSelected || "";
      this.speachGenerated.generationOptions.avatar = this.styleAvatar;
      this.speachGenerated.generationOptions.background = this.styleBackground;
      this.speachGenerated.generationOptions.voice = this.styleVoice;
      this.speachGenerated.generationOptions.imageStyle = this.styleImageStyle;
      this.speachGenerated.generationOptions.visualTemplate = this.styleVisualTemplate;
      this.speachGenerated.generationOptions.annotationsEnabled = this.styleAnnotationsEnabled;
      this.speachGenerated.generationOptions.useAvatar = this.styleUseAvatar;
      // Pre-compute the per-subchapter hidden prompt and persist it on the
      // subchapter so speach-core saves it in the JSON. This survives Continue
      // via AI even if the SUB_CHAPTER_TYPE_CONFIG evolves later.
      this.precomputeSubChapterPrompts();
      axios.post(`/recorder/aiSpeachGenerator/validateSteps?linkID=${this.linkId}`, this.speachGenerated).then(async resp => {
        this.speachToMap = resp.data;
        if (goToEditing) {
          document.location = toSpeachEditingPage(this.speachToMap.speachID);
        } else {
          // TODO add speachID to URL
        }
        await delay(1000);
        this.generationInProgress = false;
      }).catch(e => {
        console.error(e);
        alertError(this.$t('aiContent.error'));
      });
    }
  }
  async generateAllSpeachAutoMode() {
    if (!this.speachToMap || this.pushingChapters) {
      return;
    }
    this.pushingChapters = true;
    try {
      const speachID = this.speachToMap.speachID;
      const formData = new FormData();
      formData.append('speachID', speachID);
      await axios.post('/recorder/aiSpeachGenerator/pushChaptersForGeneration', formData);
      this.generatedSpeachID = speachID;
      // Keep the same dialog open, switch it to the "generation started" state.
      this.showGenerationStarted = true;
      // The dialog's "close" button stays disabled for 10s; clicking it then
      // sends the user to the speach editor (each chapter shows its own
      // in-progress page there).
      this.startCloseCountdown();
    } catch (e) {
      console.error(e);
      alertError(this.$t('aiContent.error'));
    } finally {
      this.pushingChapters = false;
    }
  }
  startCloseCountdown() {
    this.closeCountdown = 10;
    if (this.closeCountdownTimer !== null) {
      window.clearInterval(this.closeCountdownTimer);
    }
    this.closeCountdownTimer = window.setInterval(() => {
      this.closeCountdown -= 1;
      if (this.closeCountdown <= 0) {
        this.closeCountdown = 0;
        if (this.closeCountdownTimer !== null) {
          window.clearInterval(this.closeCountdownTimer);
          this.closeCountdownTimer = null;
        }
      }
    }, 1000);
  }
  get closeButtonLabel() {
    const base = this.$t('aiContent.generationStarted.close');
    return this.closeCountdown > 0 ? `${base} (${this.closeCountdown}s)` : base;
  }
  closeGenerationStartedAndEdit() {
    if (this.closeCountdown > 0 || !this.generatedSpeachID) {
      return;
    }
    document.location = toSpeachEditingPage(this.generatedSpeachID);
  }
  beforeDestroy() {
    if (this.closeCountdownTimer !== null) {
      window.clearInterval(this.closeCountdownTimer);
      this.closeCountdownTimer = null;
    }
  }
  async launchChapterGeneration(indexChapter, indexSubchapter) {
    if (!this.speachToMap) {
      return;
    }
    const subchapter = this.speachGenerated?.chapters?.[indexChapter]?.subchapters?.[indexSubchapter];
    const type = subchapter?.type || SubChapterType.SLIDE;
    // QUIZ subchapters are generated inline (no Weet editor): call the AI quiz
    // pipeline directly and record the questions on the chapter.
    if (type === SubChapterType.QUIZ) {
      await this.generateQuizForSubChapter(indexChapter, indexSubchapter);
      return;
    }
    this.indexLecon = indexChapter;
    this.indexChapter = indexSubchapter;
  }
  /**
   * One-click ("simple" mode) AI quiz generation for a QUIZ subchapter.
   * Uses the subchapter's subjects as the source content, reuses the existing
   * AIQuizGenerator generate/record endpoints, then flags the subchapter as
   * generated so the shared success UI shows.
   */
  async generateQuizForSubChapter(indexChapter, indexSubchapter) {
    const key = indexChapter + "-" + indexSubchapter;
    const subchapter = this.speachGenerated?.chapters?.[indexChapter]?.subchapters?.[indexSubchapter];
    const chapitre = this.speachToMap?.lecons?.[indexChapter]?.chapitres?.[indexSubchapter];
    if (!subchapter || !chapitre) {
      return;
    }
    // The quiz is based on the subjects the LLM assigned to this QUIZ subchapter.
    const subjects = subchapter.subjects || [];
    const textContent = [subchapter.title, ...subjects].filter(Boolean).join('\n');
    if (!textContent.trim()) {
      alertError(this.$t('aiContent.error'));
      return;
    }
    this.quizGeneratingKeys = {
      ...this.quizGeneratingKeys,
      [key]: true
    };
    try {
      const formData = new FormData();
      formData.append('nbQuestionsToGenerate', '0'); // 0 = let the LLM pick the count
      formData.append('maxNbQuestionsAllowed', String(this.QUIZ_MAX_QUESTIONS));
      formData.append('existingQuestions', JSON.stringify([]));
      formData.append('selectedChapters', JSON.stringify([]));
      formData.append('textContent', textContent);
      formData.append('selectedLang', this.languageSelected);
      const jobID = await axios.post('/recorder/aiQuizGenerator/generate/' + chapitre.id, formData).then(r => r.data);
      const quiz = await waitingJob(jobID);
      if (!quiz?.questions?.length) {
        alertError(this.$t('aiQuizGeneration.popup.noQuestionGenerated'));
        return;
      }
      await axios.post('/recorder/aiQuizGenerator/record/' + chapitre.id, quiz);
      // Reuse the shared success UI (keyed the same way as the Weet flow).
      this.weetIDMap[key] = 'QUIZ';
    } catch (e) {
      console.error(e);
      alertError(this.$t('aiContent.error'));
    } finally {
      const copy = {
        ...this.quizGeneratingKeys
      };
      delete copy[key];
      this.quizGeneratingKeys = copy;
    }
  }
  isQuizGenerating(indexChapter, indexSubchapter) {
    return !!this.quizGeneratingKeys[indexChapter + "-" + indexSubchapter];
  }
  isQuizSubChapter(subchapter) {
    return (subchapter?.type || SubChapterType.SLIDE) === SubChapterType.QUIZ;
  }
  /** Label of the generate button, driven by the subchapter type. */
  generateButtonLabel(subchapter) {
    const type = subchapter?.type || SubChapterType.SLIDE;
    switch (type) {
      case SubChapterType.QUIZ:
        return this.$t('aiContent.generateQuiz');
      case SubChapterType.EXPLAINER:
        return this.$t('aiContent.generateVideoExplainer');
      default:
        return this.$t('aiContent.generateSlideVideo');
    }
  }
  onCloseContentGeneration(data) {
    // Handle both string (for backward compatibility) and object formats
    let weetID;
    let mappingInfo = null;
    if (typeof data === 'string') {
      weetID = data;
    } else {
      weetID = data.weetID;
      mappingInfo = data;
    }
    // Store the weetID in the map
    this.weetIDMap[this.indexLecon + "-" + this.indexChapter] = weetID;
    // If we have mapping info, ensure the chapter ID is mapped in speachGenerated
    if (mappingInfo && this.speachGenerated && this.indexLecon >= 0 && this.indexChapter >= 0) {
      if (this.speachGenerated.chapters[this.indexLecon] && this.speachGenerated.chapters[this.indexLecon].subchapters[this.indexChapter]) {
        const generatedSubchapter = this.speachGenerated.chapters[this.indexLecon].subchapters[this.indexChapter];
        // Update chapterID if available in the mapping info
        if (mappingInfo.speachChapterId) {
          generatedSubchapter.chapterID = mappingInfo.speachChapterId;
          console.log(`Updated chapter ID mapping for chapter ${this.indexLecon + 1}.${this.indexChapter + 1}: ${mappingInfo.speachChapterId}`);
        }
      }
    }
    // Reset indices
    this.indexChapter = -1;
    this.indexLecon = -1;
  }
  getWeetIdForChapter(indexlecon, indexChapter) {
    return this.weetIDMap[indexlecon + "-" + indexChapter];
  }
  get subChapterTypeOptions() {
    return Object.values(SubChapterType).map(v => ({
      value: v,
      label: this.$t('aiContent.subChapterType.' + v)
    }));
  }
  onSubChapterTypeChange(newType, indexChapter, indexSubChapter) {
    const sub = this.speachGenerated?.chapters?.[indexChapter]?.subchapters?.[indexSubChapter];
    if (sub) {
      sub.type = newType;
      // Reset the persisted prompt so it gets recomputed on next save/generation
      // with the new type's rules.
      sub.hiddenPromptGeneration = undefined;
    }
  }
  /**
   * Populate hiddenPromptGeneration on every subchapter based on its type and
   * the current visual template. Called right before POST /validateSteps so the
   * prompts land in the AISpeach JSON persisted by speach-core.
   */
  precomputeSubChapterPrompts() {
    if (!this.speachGenerated?.chapters) return;
    const tpl = getVisualTemplateByKey(this.styleVisualTemplate);
    const templateHiddenPrompt = tpl?.hiddenPrompt || null;
    const trainingModuleJson = JSON.stringify(this.speachGenerated, null, 2);
    for (let ci = 0; ci < this.speachGenerated.chapters.length; ci++) {
      const chapter = this.speachGenerated.chapters[ci];
      if (!chapter.subchapters) continue;
      for (let si = 0; si < chapter.subchapters.length; si++) {
        const sub = chapter.subchapters[si];
        // Skip if a prompt is already there (e.g., loaded from an existing JSON)
        // and its type hasn't changed since — trust the persisted value.
        if (sub.hiddenPromptGeneration) continue;
        const subChapterType = sub.type || SubChapterType.SLIDE;
        const typeConfig = getSubChapterTypeConfig(subChapterType);
        const indexSubChapter = ci + 1 + "-" + (si + 1);
        let hp = `Generate a script **only** for sub-chapter index <subChapterSelected>${indexSubChapter}</subChapterSelected> ` + `titled "${sub.title}" of the training module "${this.speachGenerated.title}".\n\n` + `<subChapterSubjects>\n`;
        if (sub.subjects && sub.subjects.length > 0) {
          hp += `The script must cover ONLY the following subjects:\n` + sub.subjects.map((subject, idx) => `${idx + 1}. ${subject}`).join('\n') + '\n' + `</subChapterSubjects>\n\n`;
        }
        hp += `<trainingModule>\n${trainingModuleJson}\n</trainingModule>\n\n` + `Instructions:\n` + `- Cover ONLY the subjects listed in <subChapterSubjects>\n` + `- Follow the structure defined in the training module plan\n` + `- Use only the document pages and videos provided for this specific sub-chapter\n` + `- Maintain continuity with previous sub-chapters without repeating introductory content already covered\n` + `- Start directly with the sub-chapter content\n`;
        hp += typeConfig.buildPromptSuffix(templateHiddenPrompt);
        sub.hiddenPromptGeneration = hp;
      }
    }
  }
  isDocumentPDF(name) {
    for (const file of this.aiFiles) {
      if (file.name === name) {
        return "DOCUMENT" === file.data?.type;
      }
    }
    return false;
  }
  convertTimeStamp(time) {
    return prettyMilliseconds(parseInt(time + "", 10) * 1000, {
      secondsDecimalDigits: 0,
      compact: true,
      colonNotation: true
    });
  }
  getDocumentForPage(page) {
    const indexDoc = page.documentNumber;
    return this.aiFiles[indexDoc - 1];
  }
  getPageImage(page) {
    // console.log(this.aiFiles,this.uploadedFiles);
    const doc = this.getDocumentForPage(page);
    if (doc && doc.data) {
      if (doc.data.type === "DOCUMENT") {
        const docWrap = doc.data.data;
        if (docWrap.pages.length > page.pageNumber - 1) {
          return "data:image/jpeg;base64," + docWrap.pages[page.pageNumber - 1].imageB64;
        }
      }
    }
    return "";
  }
  prevSlide(ref) {
    // @ts-ignore
    this.$refs[ref][0].prev();
  }
  nextSlide(ref) {
    // @ts-ignore
    this.$refs[ref][0].next();
  }
  onDurationChange(value) {
    this.durationSelected = value;
  }
  onLanguageChange(value) {
    this.languageSelected = value;
  }
  onAllowReorder(value) {
    this.allowReorderSelected = value;
  }
  onSpecificPromptChange(value) {
    this.specificPromptSelected = value;
  }
};
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "aiFiles", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "uploadedFiles", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "language", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "duration", void 0);
__decorate([Prop({
  default: ""
})], AIStepsGenerator.prototype, "specificPrompt", void 0);
__decorate([Prop({
  default: true
})], AIStepsGenerator.prototype, "allowReorder", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "weetEndpoint", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "generationMode", void 0);
__decorate([Prop({
  default: false
})], AIStepsGenerator.prototype, "fullContentGeneration", void 0);
__decorate([Prop({
  default: false
})], AIStepsGenerator.prototype, "demoMode", void 0);
__decorate([Prop({
  default: ''
})], AIStepsGenerator.prototype, "linkId", void 0);
__decorate([Prop({
  default: null
})], AIStepsGenerator.prototype, "styleAvatar", void 0);
__decorate([Prop({
  default: null
})], AIStepsGenerator.prototype, "styleBackground", void 0);
__decorate([Prop({
  default: null
})], AIStepsGenerator.prototype, "styleVoice", void 0);
__decorate([Prop({
  default: null
})], AIStepsGenerator.prototype, "styleImageStyle", void 0);
__decorate([Prop({
  default: null
})], AIStepsGenerator.prototype, "styleVisualTemplate", void 0);
__decorate([Prop({
  default: false
})], AIStepsGenerator.prototype, "styleExplainerEnabled", void 0);
__decorate([Prop({
  default: true
})], AIStepsGenerator.prototype, "styleQuizEnabled", void 0);
__decorate([Prop({
  default: false
})], AIStepsGenerator.prototype, "styleAnnotationsEnabled", void 0);
__decorate([Prop({
  default: false
})], AIStepsGenerator.prototype, "styleFullExplainer", void 0);
__decorate([Prop({
  default: true
})], AIStepsGenerator.prototype, "styleUseAvatar", void 0);
__decorate([Watch('speachToMap')], AIStepsGenerator.prototype, "onSpeachToMapChange", null);
AIStepsGenerator = __decorate([Component({
  emits: ['generationPhase', 'back'],
  components: {
    ConfirmDialog,
    AISpeachGeneratorPanelOption,
    AIChapterContentGenerator,
    WDialog,
    IconButton,
    LightButton,
    Loader,
    WInput,
    BigButton,
    StandardButton,
    Icon
  }
})], AIStepsGenerator);
export default AIStepsGenerator;